import logo from "./logo.svg";
import "./App.css";
import React from "react";
import web3 from "./web3";
import lottery from "./lottery";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = { manager: "", players: [], balance: "", message: "" };
  }

  async componentDidMount() {
    const manager = await lottery.methods.manager().call();
    const players = await lottery.methods.getPlayers().call();
    const balance = await web3.eth.getBalance(lottery.options.address);

    this.setState({ manager: manager, players: players, balance: balance });
  }

  onSubmit = async (event) => {
    event.preventDefault();

    const accounts = await web3.eth.getAccounts();

    this.setState({ message: "Waiting on transaction success..." });

    await lottery.methods.enter().send({
      from: accounts[0],
      value: web3.utils.toWei("0.1", "ether"),
    });

    this.setState({ message: "You have been entered!" });
  };

  onClick = async (event) => {
    const accounts = await web3.eth.getAccounts();

    this.setState({ message: "Waiting on transaction success..." });

    await lottery.methods.pickWinner().send({
      from: accounts[0],
    });

    this.setState({
      message: "Winner has been picked! Money has been transferred",
    });
  };

  render() {
    console.log("Web 3 Version ", web3.version);
    web3.eth.getAccounts().then(console.log);

    return (
      <div>
        <h2>Lottery Contact</h2>
        <p>
          This Contract is managed by {this.state.manager}. <br />
          There are {" " + this.state.players.length} player(s) in this round!
          Current Reward is: {web3.utils.fromWei(this.state.balance, "ether")}{" "}
          ETH!
        </p>

        <hr />

        <form onSubmit={this.onSubmit}>
          <h4>Send 0.1 ETH to Enter this round</h4>
          <button>Enter (SEND)</button>
        </form>

        <hr />
        <h4>Are You Manager of the Contract ?</h4>
        <button onClick={this.onClick}>Pick Winner!</button>

        <hr />
        <h1>{this.state.message}</h1>
      </div>
    );
  }
}
export default App;
